import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/useAuthStore";
import { hasRememberedIdentity } from "../helpers/rememberedIdentity";

const AuthProtected = ({ children }: { children: React.ReactNode }) => {
  const user = useAuthStore((s) => s.user);

  if (!user?.token) {
    return <Navigate to={hasRememberedIdentity() ? "/welcome-back" : "/login"} replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;